import axios from "axios";
import { ENDPOINTS } from "./_config";

function getObjectKeys(obj) {
  return Object.keys(obj);
}

export async function fetchTrialCount(trialID, setState, setAllStatus, token) {
  const url = `${ENDPOINTS.TRIALS.TRIAL_STATUS_COUNT}?trialID=${trialID}`;

  try {
    const response = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const preData = await response.json();
    const data = preData.data;
    const allStatus = getObjectKeys(data);
    setAllStatus(["All", ...allStatus]);
    const totalCount = Object.entries(data)
      .filter(([key]) => key !== "Queued" && key !== "Skipped")
      .reduce((sum, [, value]) => sum + value, 0);
    const updatedData = { ...data, All: totalCount };

    setState(updatedData);
  } catch (error) {
    console.error("Error fetching trial count:", error);
  }
}

export async function getPatientsByTrial({
  trialID,
  statusID = "",
  Filters = "",
  Columns = "",
  Sorts = "",
  Page = 1,
  PageSize = 10,
}) {
  try {
    const response = await axios.get(
      "/api/trial/get-patient-by-trial-pagination",
      {
        params: {
          trialID,
          statusID,
          Filters,
          Columns,
          Sorts,
          Page,
          PageSize,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching patients:", error);
    throw error;
  }
}

export default getPatientsByTrial;

// getQueuePatientByTrial(trialID, token, setPatientsData);
